import { PERSONALIZATION_API_HOST, PERSONALIZATION_API_KEY } from './constants';

const subscribeUser = async (
  email: string,
  country: string,
  formName: string[],
  pagePath: string,
  signupConsent?: boolean,
  signupSource?: string,
  signupMedium?: string,
  signupCampaign?: string,
  source?: string,
  medium?: string,
  campaign?: string,
  pianoUid?: string,
  zeroBounceValidated?: boolean,
  zeroBounceStatus?: string,
  zeroBounceSubStatus?: string,
) => {
  const body = {
    country,
    email,
    formName,
    pagePath,
    signupConsent,
    signupSource,
    signupMedium,
    signupCampaign,
    source,
    medium,
    campaign,
    pianoUid,
    zeroBounceValidated,
    zeroBounceStatus,
    zeroBounceSubStatus,
  };

  const response = await fetch(`${PERSONALIZATION_API_HOST}/subscribeUser`, {
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': PERSONALIZATION_API_KEY,
    },
    method: 'POST',
  });

  if (!response.ok) throw new Error('API error');

  return true;
};

export default subscribeUser;
